
import React from 'react';

export default function KeySymbol({symbol, color="slate"}) {
    return <div className={`hidden sm:inline-block text-xs p-1 rounded border ml-2 border-${color}-500 bg-transparent`}>{symbol}</div>
}